export const statuses = [
  { label: 'Ativo', id: 'active' },
  { label: 'Pausado', id: 'paused' },
]

// { label: 'Deletado', id: 'deleted' },
// { label: 'Arquivado', id: 'archived' },
